<template>
  <div>
    <b-button type="submit" variant="primary" :disabled="buttonDisabled || disabled" class="d-flex" @click="setWaiting">
      <p>{{ message }}</p>
      <font-awesome-icon icon="circle-notch" class="text-white loading-icon vertical-align-middle" v-if="notification === null && waiting" spin></font-awesome-icon>
      <transition name="fade">
        <div class="white-icon ml-2" v-if="notification === 'success'">
          <p class="white-iconfix">
            <font-awesome-icon icon="check-circle" class="green vertical-align-middle"></font-awesome-icon>
          </p>
        </div>
        <div class="white-icon ml-2" v-if="notification === 'error'">
          <p class="white-iconfix">
            <font-awesome-icon icon="times-circle" class="red vertical-align-middle"></font-awesome-icon>
          </p>
        </div>
      </transition>
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'notification-button',
  data: function () {
    return {
      waiting: false,
      waitingTimeout: null,
      buttonDisabled: false,
      buttonTimeout: null,
      notificationClearTimeout: null
    }
  },
  props: {
    message: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    notification: {
      type: String,
      required: false,
      default: null
    },
    field: {
      type: String,
      required: true
    },
    instant: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    setWaiting: function () {
      let self = this
      self.buttonTimeout = setTimeout(function () {
        self.buttonDisabled = true
      })
      self.waitingTimeout = setTimeout(function () {
        self.waiting = true
      }, 100)
    }
  },
  watch: {
    notification: function () {
      let self = this
      clearTimeout(self.buttonTimeout)
      self.buttonDisabled = false
      clearTimeout(self.waitingTimeout)
      self.waiting = false
      clearTimeout(self.notificationClearTimeout)
      let time = 2000
      if (this.instant && this.notification === 'success') {
        time = 0
      }
      if (this.notification !== null) {
        this.notificationClearTimeout = setTimeout(function () {
          self.$root.$emit('resetNotification', self.field)
        }, time)
      }
    }
  }
}
</script>

<style scoped>
  .loading-icon {
    margin-left: 6px;
    margin-top: 3px;
  }

  .white-icon {
    background: #fff;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    position: relative;
    top: 4px;
  }

  .white-iconfix {
    position: relative;
    top: -6px;
    left: -2px;
  }

  .vertical-align-middle {
    vertical-align: middle;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/NotificationButton.vue